import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import Swal from "sweetalert2";

import BASE_API_URL from "../../../../api/api.js";
import apiInstance from "../../../../Utils/api.js";
function CatRegister() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [saleReturnLists, setSaleReturnLists] = useState([]);
  const [cashDownList, setCashDownList] = useState([]);
  const [otherList, setOtherList] = useState([]);
  const [showCashDown, setShowCashDown] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [showSearchDate, setShowSearchDate] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [searchByDateList, setSearchByDateList] = useState([]);

  const handleChoose = (event) => {
    if (event == "Cash Down") {
      setCashDownList(
        saleReturnLists.filter((el) => el.returnType == "Full Cash"),
      );
      setShowCashDown(true);
      setShowOther(false);
      setShowOrigin(false);
      setShowSearchDate(false);
    } else {
      setOtherList(
        saleReturnLists.filter((el) => el.returnType == "SubTreatment"),
      );
      setShowCashDown(false);
      setShowOther(true);
      setShowOrigin(false);
      setShowSearchDate(false);
    }

    if (event == "All") {
      setShowOrigin(true);
      setShowCashDown(false);
      setShowOther(false);
      setShowSearchDate(false);
    }
  };

  const handleFilterDate = () => {
    console.log(from, "from");
    console.log(to, "to");
    setSearchByDateList(
      saleReturnLists.filter(
        (el) =>
          el.createdAt >= from && (el.createdAt = to || el.createdAt < to),
      ),
    );
    // console.log(
    //   saleReturnLists.filter(el => el.createdAt >= from && el.createdAt <= to),
    //   'filter date'
    // )
    setShowSearchDate(true);
    setShowOrigin(false);
    setShowCashDown(false);
    setShowOther(false);
  };
  useEffect(() => {
    const getPackage = async () => {
      try {
        const res = await api.get("sale-returns");
        console.log(res.data.list, "sa lis list");
        setSaleReturnLists(res.data.list);
      } catch (err) {}
    };
    getPackage();
  }, []);
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2 card-header py-3">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Sale Return List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="row">
                  <div className="col-6">
                    <div className="row">
                      <div className="form-group col-md-4">
                        <label>From</label>
                        <input
                          type="date"
                          name="from"
                          id="from"
                          onChange={(e) => setFrom(e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label>To</label>
                        <input
                          type="date"
                          name="to"
                          id="to"
                          onChange={(e) => setTo(e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group col-md-2">
                        <button
                          className="btn btn-sm btn-primary"
                          style={{ marginTop: "40px" }}
                          onClick={() => handleFilterDate()}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="offset-2 col-4">
                    <div
                      className="offset-5 col-md-6"
                      style={{ marginTop: "2.6em" }}
                    >
                      <div className="form-group">
                        <select
                          name="currency"
                          id=""
                          className="form-control "
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleChoose(e.target.value)}
                        >
                          <option hidden>Filter By Types</option>
                          <option value="All">All</option>

                          <option value="Cash Down">Cash Down</option>
                          <option value="Other Treatment">
                            Other Treatment
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 py-3 card">
                    <div class="card-header">
                      <div class="row" id="trial_balance"></div>
                    </div>
                    <div class="table-responsive text-black" id="slimtest2">
                      <table class="table table-hover px-3" id="filter_date">
                        <thead class="bg-info text-white">
                          <tr>
                            <th>No.</th>
                            <th>Date</th>
                            <th>Patient Name</th>
                            <th>Treatment</th>
                            <th>Total Charge</th>
                            <th>Type</th> {/*Full Cash / SubTreament*/}
                            <th>Cash Back</th>
                            <th>Treatment Unit</th>
                            <th>Description</th>
                          </tr>
                        </thead>

                        {showSearchDate &&
                          searchByDateList
                            .slice(0)
                            .reverse()
                            .map((pack, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>
                                  <td>
                                    {pack.createdAt
                                      ? pack.createdAt.split("T")[0]
                                      : ""}
                                  </td>
                                  <td>
                                    {pack.relatedPatient
                                      ? pack.relatedPatient.name
                                      : ""}
                                  </td>
                                  <td>
                                    {pack.relatedTreatmentSelection
                                      ? pack.relatedTreatmentSelection
                                          .relatedTreatment.treatmentName.name
                                      : ""}
                                  </td>

                                  <td>{pack.totalAmount}</td>
                                  <td>{pack.returnType}</td>
                                  <td>{pack.cashBack}</td>
                                  <td className="">
                                    {pack.returnType == "SubTreatment" &&
                                    pack.relatedSubTreatment
                                      ? pack.relatedSubTreatment
                                          .relatedTreatment.name
                                      : ""}
                                  </td>
                                  <td className="">
                                    {pack.relatedSubTreatment
                                      ? pack.relatedSubTreatment
                                          .relatedTreatment.description
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                        {showOrigin &&
                          saleReturnLists
                            .slice(0)
                            .reverse()
                            .map((pack, i) => (
                              <tbody className="">
                                <tr>
                                  <td>{++i}</td>
                                  <td>
                                    {pack.createdAt
                                      ? pack.createdAt.split("T")[0]
                                      : ""}
                                  </td>
                                  <td>
                                    {pack.relatedPatient
                                      ? pack.relatedPatient.name
                                      : ""}
                                  </td>
                                  <td>
                                    {pack.relatedTreatmentSelection
                                      ? pack.relatedTreatmentSelection
                                          .relatedTreatment.treatmentName.name
                                      : ""}
                                  </td>

                                  <td>{pack.totalAmount}</td>
                                  <td>{pack.returnType}</td>
                                  <td>{pack.cashBack}</td>
                                  <td className="">
                                    {pack.returnType == "SubTreatment" &&
                                    pack.relatedSubTreatment
                                      ? pack.relatedSubTreatment
                                          .relatedTreatment.name
                                      : ""}
                                  </td>
                                  <td className="">
                                    {pack.relatedSubTreatment
                                      ? pack.relatedSubTreatment
                                          .relatedTreatment.description
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                        {showCashDown &&
                          cashDownList.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>
                                <td>
                                  {pack.createdAt
                                    ? pack.createdAt.split("T")[0]
                                    : ""}
                                </td>
                                <td>
                                  {pack.relatedPatient
                                    ? pack.relatedPatient.name
                                    : ""}
                                </td>
                                <td>
                                  {pack.relatedTreatmentSelection
                                    ? pack.relatedTreatmentSelection
                                        .relatedTreatment.treatmentName.name
                                    : ""}
                                </td>

                                <td>{pack.totalAmount}</td>
                                <td>{pack.returnType}</td>
                                <td>{pack.cashBack}</td>
                                <td className="">
                                  {pack.returnType == "SubTreatment" &&
                                  pack.relatedSubTreatment
                                    ? pack.relatedSubTreatment.relatedTreatment
                                        .name
                                    : ""}
                                </td>
                                <td className="">
                                  {pack.relatedSubTreatment
                                    ? pack.relatedSubTreatment.relatedTreatment
                                        .description
                                    : ""}
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        {showOther &&
                          otherList.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>
                                <td>
                                  {pack.createdAt
                                    ? pack.createdAt.split("T")[0]
                                    : ""}
                                </td>
                                <td>
                                  {pack.relatedPatient
                                    ? pack.relatedPatient.name
                                    : ""}
                                </td>
                                <td>
                                  {pack.relatedTreatmentSelection
                                    ? pack.relatedTreatmentSelection
                                        .relatedTreatment.treatmentName.name
                                    : ""}
                                </td>

                                <td>{pack.totalAmount}</td>
                                <td>{pack.returnType}</td>
                                <td>{pack.cashBack}</td>
                                <td className="">
                                  {pack.returnType == "SubTreatment" &&
                                  pack.relatedSubTreatment
                                    ? pack.relatedSubTreatment.relatedTreatment
                                        .name
                                    : ""}
                                </td>
                                <td className="">
                                  {pack.relatedSubTreatment
                                    ? pack.relatedSubTreatment.relatedTreatment
                                        .description
                                    : ""}
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </table>
                    </div>
                  </div>
                  {/* <div className="col-md-3">
                    <div className="card px-3 py-3">
                      <h5 className="card-header mb-4 text-secondary">
                        Create Reagent
                      </h5>

                      <div class="form-group">
                        <label for="code" className="text-secondary">
                          Code
                        </label>
                        <input
                          type="text"
                          id="code"
                          class="form-control border-info"
                          name="code"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Name
                        </label>
                        <input
                          type="text"
                          class="form-control border-info"
                          name="name"
                          id="name"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) =>
                            setDescription(e.target.value)
                          }></textarea>
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Flag
                        </label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="flag"
                          onChange={(e) => setFlag(e.target.value)}>
                          <option></option>
                          <option value="Service">Service</option>
                          <option value="Reagent">Reagent</option>
                        </select>
                      </div>
                      <button
                        className="btn btn-primary form-control text-center fw-5"
                        type="submit"
                        onClick={CategoryCreate}>
                        Save
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* <ExpenseDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

    </>
  );
}
export default CatRegister;
